import { getCardApi } from "@/global/api/card";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { selectCard, setCard } from "@/global/store/data/purchaseSeats/card";
import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const useGetSavedCard = () => {
  const {
    teamSchema,
    purchaseSeatConfigs: { isRepProduct },
  } = useTeamConfig();
  const dispatch = useDispatch();
  const getCard = useMutation(getCardApi);
  const savedCard = useSelector(selectCard);

  const getCardInformation = async () => {
    try {
      await getCard.mutateAsync(
        { teamSchema },
        {
          onSuccess({ data }: any) {
            if (data && data?.ccSeqId) {
              dispatch(setCard(data));
            } else {
              dispatch(setCard({ ccSeqId: "", ccType: "", dataMask: "" }));
            }
          },
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // we prevent the api call if it is a representative product
    if (!isRepProduct) getCardInformation();
  }, []);

  return {
    savedCard,
    getCard,
  };
};

export default useGetSavedCard;
